/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Save_Title_2Inputs */

const en_services_svc_save_title_2 = /** @type {(inputs: Services_Svc_Save_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepared for you.`)
};

const lv_services_svc_save_title_2 = /** @type {(inputs: Services_Svc_Save_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sagatavots Jūsu vietā.`)
};

/**
* | output |
* | --- |
* | "Prepared for you." |
*
* @param {Services_Svc_Save_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_save_title_2 = /** @type {((inputs?: Services_Svc_Save_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Save_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_save_title_2(inputs)
	return en_services_svc_save_title_2(inputs)
});